import { useState } from 'react';
import { Disclosure, Heading, type Key } from 'react-aria-components';
import ChevronDown from '@/assets/icons/ChevronDown.svg';
import { GiftCardForm } from './GiftCardForm';
import { StoredCard } from './StoredCard';
import { useGiftCards } from './useGiftCards';
import * as Styled from './GiftCards.styled';

const newCardDisclosureId = 'newCard';
const emptySet = new Set([]);

export const StoredGiftCards = () => {
  const { appliedGiftCards, storedGiftCards } = useGiftCards();

  const [selectedGiftCards, setSelectedGiftCards] = useState<Set<Key>>(
    appliedGiftCards ? new Set(appliedGiftCards) : emptySet,
  );

  const [prevStoredCards, setPrevStoredCards] = useState(storedGiftCards);

  if (prevStoredCards !== storedGiftCards) {
    const prevCardNumbers = prevStoredCards?.map(card => card.cardNumber);
    const newGiftCard =
      storedGiftCards
        ?.filter(card => !prevCardNumbers?.includes(card.cardNumber))
        .map(card => card.cardNumber) ?? [];
    setSelectedGiftCards(new Set([...appliedGiftCards, ...newGiftCard]));
    setPrevStoredCards(storedGiftCards);
  }

  return (
    <Styled.Disclosures
      allowsMultipleExpanded
      expandedKeys={selectedGiftCards}
      onExpandedChange={setSelectedGiftCards}
    >
      {storedGiftCards?.map((giftCard, idx) => (
        <StoredCard
          cardData={giftCard}
          key={giftCard.cardNumber}
          ordinal={idx + 1}
        />
      ))}
      <Disclosure id={newCardDisclosureId}>
        <Heading level={3}>
          <Styled.Trigger slot="trigger">
            Add a new gift card
            <ChevronDown />
          </Styled.Trigger>
        </Heading>
        <Styled.Panel>
          <GiftCardForm />
        </Styled.Panel>
      </Disclosure>
    </Styled.Disclosures>
  );
};
